<template>
  <div class="sp-template">
    <div class="h-title">充值</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :rules="rules" ref="rechargeForm" :model="rechargeForm" label-width="100px">
          <el-form-item :label="$route.query.billId != undefined ? '还款账号' : '充值账号'" prop="id">
            <h3 class="sub-title" v-if="$route.query.orgOwnerName && $route.query.orgOwnerName !== '' && $route.query.system !== undefined ">{{$route.query.orgOwnerName+"-" + $route.query.system}}</h3>
            <h3 class="sub-title" v-if="$route.query.orgOwnerName && $route.query.orgOwnerName !== '' && $route.query.system === undefined ">{{$route.query.orgOwnerName}}</h3>
          </el-form-item>
          <el-form-item label="收款组织">
            <h3 class="sub-title" v-if="$route.query.providerOrgName && $route.query.providerOrgName !== ''">{{$route.query.providerOrgName}}</h3>
          </el-form-item>
          <el-form-item label="信用额度" v-if="$route.query.credit && $route.query.credit !== ''">
            <h3 class="sub-title">{{$route.query.credit}}</h3>
          </el-form-item>
          <el-form-item label="可用余额" v-if="$route.query.creditUseable && $route.query.creditUseable !== ''">
            <h3 class="sub-title">{{$route.query.creditUseable}}</h3>
          </el-form-item>
          <el-form-item label="欠款金额">
            <h3 class="sub-title" style="color: #F56C6C;">{{($route.query.credit - $route.query.creditUseable > 0) ? ($route.query.credit - $route.query.creditUseable).toFixed(2) : '0'}}</h3>
          </el-form-item>
          <el-form-item label="充值币种">
            <el-radio-group v-model="rechargeForm.currency">
              <el-radio label="人民币"></el-radio>
              <!-- <el-radio label="美元"></el-radio> -->
            </el-radio-group>
          </el-form-item>
          <el-form-item label="按订单充值">
            <el-button type="primary" icon="el-icon-check" size="small" plain @click="openDialogForm()">选择订单</el-button>
            <!-- <el-button v-if="isDisabled" type="primary" size="small" plain @click="checkDepositTransaction()">查看</el-button> -->
          </el-form-item>
          <el-form-item label="付款账户" prop="accountRemark">
            <el-input v-model.lazy="rechargeForm.accountRemark" placeholder="付款账户" size="medium"></el-input>
          </el-form-item>
          <el-form-item label="还款金额" prop="topUpAmount" v-if="$route.query.debtAmount !== undefined">
            <el-input v-model.lazy="rechargeForm.topUpAmount" placeholder="还款金额" size="medium" clearable></el-input>
          </el-form-item>
          <el-form-item label="充值金额" prop="topUpAmount" v-else>
            <el-input v-model.lazy="rechargeForm.topUpAmount" placeholder="充值金额" size="medium" clearable :disabled="isDisabled"></el-input>
            <i v-if="isDisabled" class="el-icon-circle-close-outline" style="color: #F56C6C;" title="删除所有订单" @click="deleteAll"></i>
          </el-form-item>
          <el-form-item label="充值方式">
            <el-radio v-model="rechargeForm.paymentTool" label="Offline_Alipay">线下支付宝</el-radio>
            <el-radio v-model="rechargeForm.paymentTool" label="BankTransfer">银行转账</el-radio>
            <el-radio v-model="rechargeForm.paymentTool" label="Rests">其他</el-radio>
          </el-form-item>

          <el-form-item label="银行类型" v-if="rechargeForm.paymentTool=='BankTransfer'" prop="bank" class="is-required">
						<el-select v-model="rechargeForm.bank"  clearable>
              <el-option v-for="item in banks" :key="item.name" :label="item.name" :value="item.name"></el-option>
            </el-select>
					</el-form-item>
           <el-form-item label="类型" v-if="rechargeForm.paymentTool=='Offline_Alipay'" prop="bank" class="is-required">
						<el-select v-model="rechargeForm.bank"  clearable>
              <el-option v-for="item in alipaybanks" :key="item.name" :label="item.name" :value="item.name"></el-option>
            </el-select>
					</el-form-item>

          <el-form-item label="上传凭证"  class="is-required" >
            <el-upload action="#" :file-list="imgListCertificateImgs" accept="image/png,image/gif,image/jpg,image/jpeg" list-type="picture-card" :limit="1" :on-change="changeCertificateImg" :on-remove="rmCertificateImg" :auto-upload="false">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" v-model="rechargeForm.remark" size="medium" style="width: 757px;"></el-input>
          </el-form-item>
          <div class="tips-content">
            <h3 class="sub-title">温馨提示</h3>
            <ul class="tips">
              <li>1、通过信用卡的快捷支付有500元限制；超过500元时您可以选择其它方式支付；</li>
              <li>2、如您有欠费账单，充值后会优先补扣欠费账单；</li>
              <li>3、充值后请及时对支付订单进行结算，以免影响正常服务。</li>
            </ul>
          </div>
          <el-form-item>
            <el-button size="small" type="primary" @click="topUp('rechargeForm')">{{$route.query.billId != undefined ? '还 款' : '充 值'}}</el-button>
            <el-button size="small" @click="goBack()">返 回</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <!-- 按订单充值--弹层 -->
    <el-dialog title="按订单充值" class="order-charge__dialog" width="50%" :visible.sync="dialogVisible" :close-on-click-modal="noClose" @open="show()">
      <el-form :inline="true" size="small" :model="searchOrderForm">
        <el-row>
          <el-col :md="12">
            <el-form-item label="订单号">
              <el-input style="width: 300px;" v-model="number" type="textarea" placeholder="多个订单号用回车分割" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="开始日期">
          <el-date-picker v-model="searchOrderForm.startDate" type="datetime" :clearable="true" value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期">
          <el-date-picker v-model="searchOrderForm.endDate" type="datetime" :clearable="true" value-format="yyyy-MM-dd HH:mm:ss" placeholder="结束日期"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查 询</el-button>
          <el-button size="small" type="success" @click="confirm">确 定</el-button>
        </el-form-item>
      </el-form>
      <div class="statistics">
        <span class="text">总金额: <b class="number">{{totalAmount}}</b></span>
        <span class="text">总部分结算金额: <b class="number">{{totalPartialPaymentAmount}}</b></span>
      </div>
      <el-table :data="orderChargeData" ref="multipleTable" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="订单号" prop="refNumber"></el-table-column>
        <el-table-column label="描述" prop="description"></el-table-column>
        <el-table-column label="币种" prop="currency" width="100"></el-table-column>
        <el-table-column label="金额" prop="amount" width="100"></el-table-column>
        <el-table-column label="部分结算金额" prop="partialPayment"></el-table-column>
        <el-table-column label="交易时间" prop="timestamp">
          <template slot-scope="scope">
            {{ scope.row.timestamp | formatTime }}
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <!-- <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchOrderForm.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="searchOrderForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination> -->
    </el-dialog>
    <el-dialog title="查看详情" class="order-charge__dialog" width="50%" :visible.sync="dialog">
      <el-table :data="transactionData" style="width: 100%">
        <el-table-column label="订单号" prop="refNumber"></el-table-column>
        <el-table-column label="描述" prop="description"></el-table-column>
        <el-table-column label="币种" prop="currency"></el-table-column>
        <el-table-column label="金额" prop="amount"></el-table-column>
        <el-table-column label="部分结算金额" prop="partialPayment"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <i class="el-icon-delete" @click="deleted(scope.$index)"></i>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="deleteAll">清 空</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    var checkBank = (rule, value, callback) => {
      if(this.rechargeForm.paymentTool=='BankTransfer'){
        if(!this.rechargeForm.bank){
          return callback(new Error("请选择银行类型"));
        }
      }
      callback();      
    };
    return {
      isDisabled: false,
      isChargeByOrder: "no",
      noClose: false,
      number: "",
      searchOrderForm: {
        orderIds: [],
        orgOwnerId: "",
        providerOrgId: "",
        systemId: "",
        currentPage: null,
        pageSize: null,
        startDate: null,
        endDate: null
      },
      total: 0,
      orderChargeData: [],
      transactionData: [],
      rechargeForm: {
        id: "",
        orgOwnerId: "",
        currency: "人民币",
        accountRemark: "",
        topUpAmount:
          this.$route.query.credit - this.$route.query.creditUseable > 0
            ? (
                this.$route.query.credit - this.$route.query.creditUseable
              ).toFixed(2)
            : "",
        paymentTool: "Offline_Alipay",
        remark: "",
        bank: '',
        paymentForTxIds: ""
      },
      banks: [
        {id: 'zhongxin', name: '中信银行'},
        {id: 'zhaoshang', name: '招商银行'},
        {id: 'zhaoshangshenzhen1', name: '招商银行深圳高新园支行'},
        {id: 'huaqi', name: '花旗银行'},
        {id: 'beijing', name: '北京中国银行'},
        {id: 'jiaotong', name: '交通银行'},
        {id: 'la', name: 'LA银行'},
        {id: 'nongye', name: '农业银行'},
        {id: 'else', name: '其他'}
      ],
      alipaybanks: [
        {id: 'shenzhen', name: '深圳'},
        {id: 'beijing', name: '北京'}
      ],
      rules: {
        topUpAmount: [
          { required: true, message: "请输入充值金额", trigger: "blur" },
          {
            pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
            message: "充值金额只能为数字，并且不能小于零",
            trigger: "blur"
          }
        ],
        accountRemark: [
          { required: true, message: "请输入付款账户", trigger: "blur" }
        ],
        bank: [{ validator: checkBank, trigger: "blur" }]
      },
      accounts: [],
      imgListCertificateImgs: [],
      certificateImg: "",
      payee: "",
      time: 0,
      achieveQRCodeImage: "",
      dialogVisible: false,
      flag: 0,
      multipleSelection: [],
      temp: [],
      dialog: false,
      totalAmount: 0,
      totalPartialPaymentAmount: 0,
      totalAmount2: 0,
      totalPartialPaymentAmount2: 0
    };
  },
  components: {},
  created() {
    if (this.$route.query.debtAmount) {
      this.rechargeForm.topUpAmount = this.$route.query.debtAmount;
    }
  },
  computed: {
    paymethod() {
      switch (this.flag) {
        case 1:
          return "AliPay";
          break;
        case 2:
          return "WeChatPay";
          break;
        case 3:
          return "Allinpay";
          break;
      }
    }
  },
  filters: {
    formatTime(value) {
      if (!value) return "";
      return (
        new Date(value).getFullYear() +
        "-" +
        ("0" + (new Date(value).getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + new Date(value).getDate()).slice(-2) +
        " " +
        ("0" + new Date(value).getHours()).slice(-2) +
        ":" +
        ("0" + new Date(value).getMinutes()).slice(-2) +
        ":" +
        ("0" + new Date(value).getSeconds()).slice(-2)
      );
    }
  },
  methods: {
    onSubmit() {
      this.searchOrderForm.orderIds = [];
      this.number.split(/\n+/gim).forEach((d, i) => {
        if (d && d != "") {
          this.searchOrderForm.orderIds.push(d);
        }
      });
      this.searchOrderForm.currentPage = null;
      this.queryNoSettlementTransaction();
    },
    // 是否按订单充值
    openDialogForm() {
      this.dialogVisible = true;
      // this.queryNoSettlementTransaction();
    },
    show() {
      setTimeout(() => {
        this.temp.forEach(item => {
          this.$refs.multipleTable.toggleRowSelection(
            this.orderChargeData.find(order => order.txID === item.txID),
            true
          );
        });
      }, 500);
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row, true);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      if (this.multipleSelection.length > 0) {
        let totalAmount = 0;
        let totalPartialPaymentAmount = 0;
        this.multipleSelection.forEach((item, index) => {
          totalAmount += item.amount;
          totalPartialPaymentAmount += item.partialPayment;
        });
        this.totalAmount = totalAmount;
        this.totalPartialPaymentAmount = totalPartialPaymentAmount;
      } else {
        this.totalAmount = this.totalAmount2;
        this.totalPartialPaymentAmount = this.totalPartialPaymentAmount2;
      }
    },
    goBack() {
      this.$router.back();
    },
    changeCertificateImg(file, fileList) {
      if (file.raw.size > 1024 * 1024 * 10) {
        this.$message.error("单张照片限制最大10M");
        this.imgListCertificateImgs = [];
      } else {
        this.certificateImg = file.raw;
      }
    },
    rmCertificateImg(file, fileList) {
      this.certificateImg = "";
    },
    topUp(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if(this.rechargeForm.paymentTool=='BankTransfer'){
            if(!this.rechargeForm.bank){
              this.$message.error('请选择银行类型');
              return false;
            }
          }else{
            this.rechargeForm.bank = '';
          }
          if (this.rechargeForm.topUpAmount <= 0) {
            this.$alert("充值金额不能小于等于0", "提示", {
              confirmButtonText: "确定",
              type: "warning"
            });
            return false;
          }
          if (this.certificateImg == "" || this.certificateImg === null) {
            this.$alert("请上传凭证", "提示", {
              confirmButtonText: "确定",
              type: "warning"
            });
            return false;
          }
          this.$confirm(
            "本次充值金额为：￥" + this.rechargeForm.topUpAmount + " 元",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }
          )
            .then(() => {
              sessionStorage.removeItem("id");
              this.rechargeForm.id = this.$route.query.id;
              if (this.$route.query.billId != undefined) {
                this.rechargeForm.billId = this.$route.query.billId;
              }
              this.rechargeForm.orgOwnerId = this.$route.query.orgOwnerId;
              this.rechargeForm.providerOrgId = this.$route.query.providerOrgId;
              this.rechargeForm.topUpAmount = this.returnFloat(
                this.rechargeForm.topUpAmount
              );
              this.rechargeForm.currency = "CNY";
              this.rechargeForm.systemId = this.$route.query.system;

              var formData = new FormData();
              for (var key in this.rechargeForm) {
                formData.append(key, this.rechargeForm[key]);
              }
              formData.append("voucherImg", this.certificateImg);

              this.$request1({
                method: 'POST',
                url: '/account/offlineDeposit',
                withCredentials: true,
                data: formData
              })
                .then(response => {
                  this.rechargeForm.currency = "人民币";
                  if (response.data.success) {
                    sessionStorage.setItem("id", response.data.data);
                    window.location.href = "/success";
                  } else {
                    this.$notify.error({
                      title: "错误",
                      message: response.data.message
                    });
                  }
                })
                .catch(error => {
                  console.log(error);
                });
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    returnFloat(value) {
      var value = Math.round(parseFloat(value) * 100) / 100;
      var xsd = value.toString().split(".");
      if (xsd.length == 1) {
        value = value.toString() + ".00";
        return value;
      }
      if (xsd.length > 1) {
        if (xsd[1].length < 2) {
          value = value.toString() + "0";
        }
        return value;
      }
    },
    queryNoSettlementTransaction() {
      this.searchOrderForm.orgOwnerId = this.$route.query.orgOwnerId;
      this.searchOrderForm.providerOrgId = this.$route.query.providerOrgId;
      this.searchOrderForm.systemId = this.$route.query.system;
      this.$request1({
        method: 'POST',
        url: '/transaction/query-no-settlement-transaction',
        withCredentials: true,
        data: this.searchOrderForm
      })
        .then(response => {
          this.orderChargeData = response.data.data.transactionEntities;
          this.totalAmount = response.data.data.totalAmount;
          this.totalPartialPaymentAmount =
            response.data.data.totalPartialPaymentAmount;
          this.totalAmount2 = response.data.data.totalAmount;
          this.totalPartialPaymentAmount2 =
            response.data.data.totalPartialPaymentAmount;
          this.total = response.data.total;
          this.show();
        })
        .catch(error => {
          console.log(error);
        });
    },
    checkDepositTransaction() {
      this.dialog = true;
    },
    confirm() {
      if (this.multipleSelection.length > 0) {
        let creditAmount = 0;
        let partialPaymentAmount = 0;
        this.multipleSelection.forEach((item, index) => {
          if (!item) {
            this.multipleSelection.splice(index, 1);
          }
        });
        this.transactionData = this.multipleSelection;
        this.temp = Array.from(new Set(this.multipleSelection));
        let paymentForTxIds = [];
        this.transactionData.forEach((item, index) => {
          creditAmount += item.amount;
          partialPaymentAmount += item.partialPayment;
          paymentForTxIds.push(item.txID);
        });
        let rechargeAmount = creditAmount - partialPaymentAmount;

        if (parseInt(rechargeAmount) <= 0) {
          this.$message.error("充值金额不能小于等于0");
          return;
        }

        this.isDisabled = true;
        this.dialogVisible = false;
        this.rechargeForm.topUpAmount = rechargeAmount.toFixed(2);

        this.rechargeForm.paymentForTxIds = JSON.stringify(
          paymentForTxIds
        ).toString();
      } else {
        this.dialogVisible = false;
      }
    },
    deleted(index) {
      this.transactionData.splice(index, 1);
      if (this.transactionData.length > 0) {
        let creditAmount = 0;
        let partialPaymentAmount = 0;
        let paymentForTxIds = [];
        this.transactionData.forEach((item, index) => {
          creditAmount += item.amount;
          partialPaymentAmount += item.partialPayment;
          paymentForTxIds.push(item.txID);
        });
        this.rechargeForm.topUpAmount = (
          creditAmount - partialPaymentAmount
        ).toFixed(2);
        this.rechargeForm.paymentForTxIds = JSON.stringify(
          paymentForTxIds
        ).toString();
      } else {
        this.dialog = false;
        this.isDisabled = false;
        this.rechargeForm.topUpAmount =
          this.$route.query.credit - this.$route.query.creditUseable > 0
            ? (
                this.$route.query.credit - this.$route.query.creditUseable
              ).toFixed(2)
            : "";
        this.rechargeForm.paymentForTxIds = "";
      }
    },
    deleteAll() {
      this.transactionData = [];
      this.dialog = false;
      this.isDisabled = false;
      this.rechargeForm.topUpAmount =
        this.$route.query.credit - this.$route.query.creditUseable > 0
          ? (
              this.$route.query.credit - this.$route.query.creditUseable
            ).toFixed(2)
          : "";
      this.rechargeForm.paymentForTxIds = "";
    },
    //分页
    handleSizeChange(val) {
      this.searchOrderForm.pageSize = val;
      this.searchOrderForm.currentPage = 1;
      this.queryNoSettlementTransaction();
    },
    handleCurrentChange(val) {
      this.searchOrderForm.currentPage = val;
      this.queryNoSettlementTransaction();
    }
  }
};
</script>

<style lang="scss" scoped>
.sub-title {
  color: #646464;
  font-size: 14px;
}
.tips-content {
  margin-top: 30px;
  margin-bottom: 30px;
  .tips li {
    margin-top: 10px;
    color: #606266;
  }
}
.pay-method {
  font-size: 0;
  .method {
    position: relative;
    float: left;
    width: 236px;
    height: 86px;
    background-color: #f3f5f7;
    background-repeat: no-repeat;
    border: 2px solid #f3f5f7;
    cursor: pointer;
    &:not(:last-child) {
      margin-right: 25px;
    }
    &:hover,
    &.active {
      border-color: #f01414;
      .bottomright {
        display: block;
      }
    }
    .bottomright {
      width: 20px;
      height: 20px;
      position: absolute;
      right: 0;
      bottom: 0;
      display: none;
      i {
        position: absolute;
        right: -1px;
        bottom: 0px;
        color: #fff;
        font-size: 12px;
      }
    }
    .triangle {
      width: 0;
      height: 0;
      border-bottom: 20px solid red;
      border-left: 20px solid transparent;
    }
    &.alipay {
      background-image: url("../../../static/img/pay_s.png");
      background-position: 55px -304px;
    }
    &.wxpay {
      background-image: url("../../../static/img/pay_s.png");
      background-position: 48px -423px;
    }
    &.unionpay {
      text-align: center;
      line-height: 86px;
      > .icon {
        position: absolute;
        top: 23px;
        left: 23px;
        display: inline-block;
        width: 45px;
        height: 45px;
        img {
          max-width: 100%;
          max-height: 100%;
          vertical-align: top;
          border: 0;
        }
      }
      > .text {
        font-size: 20px;
      }
    }
  }
}
.statistics {
  text-align: right;
  font-size: 16px;
  margin-bottom: 20px;
  padding: 0 15px;
  .text {
    color: #606266;
    &:first-child {
      margin-right: 50px;
    }
    .number {
      font-weight: 700;
      color: #333;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/recharge/deposit.vue